export default __webpack_public_path__ + "static/media/addProperty.f4015a6e.png";